// extracted by mini-css-extract-plugin
module.exports = {"rightCol":"left_section-module__rightCol___ngzSB","languageDisclaimer":"left_section-module__languageDisclaimer___O1ZI1"};